/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */
import Splide from '@splidejs/splide';
import Styles from './style.scss';

// Import our default css theme for splide
import '@splidejs/splide/css';

document.addEventListener('DOMContentLoaded', () => {
	// Splide

	const splides = document.querySelectorAll('.splide');
	const mainSlideShow = document.getElementById('mainSlideShow');
	const slides = splides[0]?.querySelectorAll('li') || [];
	// this is what makes the splide carousel work
	if (!!splides && splides.length > 0) {
		splides.forEach((splide) => {
			// Grab the slide interval and convert it to an integer and milliseconds or fallback to 3000ms

			const interval = parseInt(splide.dataset.interval) * 1000 || 3000;

			return new Splide(splide, {
				speed: 2000,
				type: 'carousel',
				autoplay: true,
				perPage: 1,
				pauseOnHover: false,
				rewind: true,
				interval,
			}).mount();
		});
	}
	// if there are no slides only show the default banner that was selected in the block
	if (slides.length === 0) {
		if (mainSlideShow.querySelector('.defaultBanner')) {
			mainSlideShow.querySelector('.defaultBanner').style.display = 'block';
		}
		splides[0].style.display = 'none';
	}
});
